import { FacetValueCount, FacetValues, NumberFacetValue, ReplayAPI_NumberFacetValue } from '../../../types/Facet';
import { Field } from '../../../types/Field';

// Utility module for shared logic
const NumberFacetUtils = {
    createFilter(facetSelection: FacetValues<NumberFacetValue>, field: Field) : string {
        // facetSelection is an array of int values.
        const filterClauses = facetSelection.facetValues.map((selection: NumberFacetValue) => field.systemSettings.filterClause.replace('{{VALUE}}', selection.value.toString()).replace('{{OPERATOR}}', 'eq'));

        if (filterClauses.length === 0) {
            return "";
        }

        const filterClausesString = filterClauses.join(' and ');    
        return `(${filterClausesString})`;    
    },

    createRequest(field: Field) {
        // We alway set count to 0, so we retrieve all the values. This is required to guarantee accuracy in the count,
        // see https://learn.microsoft.com/en-us/azure/search/search-faceted-navigation?tabs=portal-facet%2Cportal-facet-response#discrepancies-in-facet-counts
        return `${field.name}, count:0`; 
    },

    extractFacetValues(facetName: string, facetValuesFromSearch: ReplayAPI_NumberFacetValue[]) : FacetValueCount<NumberFacetValue>[] {
        let extractedValues: FacetValueCount<NumberFacetValue>[] = [];
        
        facetValuesFromSearch = facetValuesFromSearch.sort((a, b) => a.value - b.value);

        facetValuesFromSearch.forEach((facetValue: ReplayAPI_NumberFacetValue) => {
            extractedValues.push({
                facetValue: new NumberFacetValue(facetName, facetValue.value),
                count: facetValue.count
            })
        });

        return extractedValues;
    },

    createUpdatedSelection(facetValue: NumberFacetValue, prevFacetSelection: FacetValues<NumberFacetValue>): FacetValues<NumberFacetValue> {                
        const isValueCurrentlySelected = prevFacetSelection.facetValues.some((item: NumberFacetValue) => item.value === facetValue.value);
        const newSelectionsOfFacet = isValueCurrentlySelected ?
            prevFacetSelection.facetValues.filter((item: NumberFacetValue) => item.value !== facetValue.value) : // Remove item
            [...prevFacetSelection.facetValues, facetValue]; // Add item

        return {
            facetName: prevFacetSelection.facetName,
            facetValues: newSelectionsOfFacet,
        };
    }
};

export default NumberFacetUtils;